// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3onCx","validationTips":"StatementDescriptor_validationTips__3hYTl"};